import { styled } from "styled-components";
import { MOBILE } from "../../constants/breakpoints";
import colors from "../../constants/colors";
import hero_bg from "../../assets/hero_bg.svg";
import { motion } from "framer-motion";

export interface I_ColProps {
    gap?: string
    maxWidth?: string
    align?: string
    justify?: string
    padding?: string
    textAlign?: string
    width?: string
    height?: string
    wrap?: string
    margin?: string
    marginTop?: string
    marginBottom?: string
    marginRight?: string
    marginLeft?: string
    order?: number
    self?: string
    border?: string
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    /* background: url(${hero_bg}); */
    /* background-color: #ffffff; */
    background-repeat: no-repeat;
    background-position: top right;
    position: relative;
    z-index: 100;
    @media (max-width: ${MOBILE}px) {
        background-size: contain;
        background: url(${hero_bg});
        background-repeat: no-repeat;
    }
`
export const Wrapper = styled.div`
    display: flex;
    width: 1140px;
    max-width: 1140px;
    margin: 0 auto;
    margin-top: 100px;
    flex-direction: column;
    .textContainer {
        display: flex;
        gap: 8px;
        margin-bottom: 15px;
        flex-direction: column;
        @media (min-width: ${MOBILE}px) {
            flex-direction: row !important;
        }
    }
    .colSpan{
        display: flex;
        flex-direction: column;
    }

    .linkText{
        cursor: pointer;
        font-weight: 700;
        font-size: 24px;
        margin-top: 25px;
        margin-bottom: 0px;
        color: ${colors.INTERFACE_COLORS_BASALT};
        &:hover {
            text-decoration: underline;
        }

        @media (max-width: ${MOBILE}px) {
            font-size: 16px;
        }
    }

    @media (max-width: ${MOBILE}px) {
        width: 90%;
        margin-top: 60px;
    }
`


export const Row = styled.div<I_ColProps>`
  display: flex;
  gap: ${(props: I_ColProps) => props.gap || '8px'};
  align-items: ${(props: I_ColProps) => props.align};
  justify-content: ${(props: I_ColProps) => props.justify};
  width: ${(props: I_ColProps) => props.width};
  margin: ${(props: I_ColProps) => props.margin};
  margin-left: ${(props: I_ColProps) => props.marginLeft};
  margin-right: ${(props: I_ColProps) => props.marginRight};
  margin-top: ${(props: I_ColProps) => props.marginTop};
  margin-bottom: ${(props: I_ColProps) => props.marginBottom};
  flex-wrap: ${(props: I_ColProps) => props.wrap};
  padding: ${(props: I_ColProps) => props.padding};
  max-width: ${(props: I_ColProps) => props.maxWidth};
  border: ${(props) => props.border};

`
export const Col = styled.div<I_ColProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props: I_ColProps) => props.gap || '8px'};
  max-width: ${(props: I_ColProps) => props.maxWidth};
  align-items: ${(props: I_ColProps) => props.align};
  justify-content: ${(props: I_ColProps) => props.justify};
  text-align: ${(props: I_ColProps) => props.textAlign};
  margin: ${(props: I_ColProps) => props.margin};
  margin-left: ${(props: I_ColProps) => props.marginLeft};
  margin-right: ${(props: I_ColProps) => props.marginRight};
  margin-top: ${(props: I_ColProps) => props.marginTop};
  margin-bottom: ${(props: I_ColProps) => props.marginBottom};
  padding: ${(props: I_ColProps) => props.padding};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  order: ${(props) => props.order};
  align-self: ${(props) => props.self};
  border: ${(props) => props.border};

`
export const ImageComp = styled.img`
    height: 300px;
    width: 300px;
`
export const NFTCardContainer = styled.span`
    /* max-width: 23%; */
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease;
    border: 3px solid #fff;
    border-radius: 14px;
    cursor: pointer;
    &:hover{
        border: 3px solid ${colors.INTERFACE_COLORS_LAVABEE_YELLOW};
        border-radius: 14px;
    }

    @media (max-width: ${MOBILE}px) {
        /* max-width: 45%; */
    }
`

export const NFTImage = styled.img`
    width: 250px;
    height: 200px;
    object-fit: cover;
    border-radius: 12px;
`
export const NFTCardDetails = styled.div`
    color: #191414;
    padding-left: 12px;
    display: flex;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    gap: 10px;
    .nftNameText {
        @media (max-width: ${MOBILE}px) {
            font-weight: 400;
            font-size: 14px;
        }
    }
`

export const Dot = styled.span`
    background: ${colors.SYSTEM_WARNING};
    /* font-size: 20px; */
    height: 12px;
    width: 12px;
    border-radius: 50%;
`

export const NFTsListContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 10px;
    column-gap: 24px;
    flex-wrap: wrap;
    position: relative;

    @media (max-width: ${MOBILE}px) {
        column-gap: auto;
    }
`

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    background-repeat: no-repeat;
    background-position: top right;
    @media (max-width: ${MOBILE}px) {
        background-size: contain;
    }
`
export const LoaderContainer = styled.span`
    display: flex;
    width: 1140px;
    margin: 0 auto;

    @media (max-width: ${MOBILE}px) {
    width: 90%;
    }
`

export const AllNFTsContainer = styled.div`
    margin-top: 75px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`
export const SpanContainer = styled.span`
    display: flex;
    border-bottom: 1px solid #ccc4b33b;
    padding-bottom: 11px;
    align-items: center;
    margin-bottom: 32px;
    cursor: pointer;
    .assetCountText{
        margin: 0;
        @media (max-width: ${MOBILE}px) {
            font-weight: 400;
            font-size: 14px;
        }
    }
    .collectionNameText{
        margin: 0;
        @media (max-width: ${MOBILE}px) {
            font-weight: 700;
            font-size: 16px;
        }
    }
`

export const NFTGroupImage = styled.img`
    margin-right: 27px;
    width: 70px;
    border-radius: 1000px;
`
export const ArrowContainer = styled.span`
    margin-left: auto;
`
export const MotionContainer = styled(motion.div)`
    display: flex;
    flex-direction: column;
    height: 110px;
    overflow-y: hidden;
    background-color: white;
    background: url();
`